/**
 * Represents the category/type of bill tariff.
 * Matches the backend enum: Alaric.Domains.CommonDb.Model.Enums.TariffCategory
 */
export enum TariffCategory {
    GeneralTariffs = 1,
    UtilityBillsTariff = 2
}

